import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

/**
 * LoadReveal. First-visit page-load animation.
 * Gold slash extends across screen, then reveals "HOL / Creative Solutions".
 * Auto-dismisses after ~1.9s. Respects prefers-reduced-motion (dismisses immediately).
 */
export function LoadReveal() {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) {
      setVisible(false);
      return;
    }
    const t = setTimeout(() => setVisible(false), 1900);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          key="load-reveal"
          data-testid="load-reveal"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          style={{
            position: "fixed",
            inset: 0,
            background: "#0A0A0A",
            zIndex: 999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            gap: 28,
          }}
        >
          <svg
            width="min(560px, 78vw)"
            height="80"
            viewBox="0 0 560 80"
            aria-hidden="true"
          >
            <motion.line
              x1="0" y1="72" x2="560" y2="8"
              stroke="#D4AF37" strokeWidth="2" strokeLinecap="round"
              initial={{ pathLength: 0 }}
              animate={{ pathLength: 1 }}
              transition={{ duration: 0.95, ease: [0.22, 1, 0.36, 1] }}
            />
          </svg>
          <motion.div
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.9, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            style={{ textAlign: "center", lineHeight: 1 }}
          >
            <div style={{
              fontFamily: "Fraunces, Georgia, serif",
              fontSize: "clamp(1.6rem, 3.6vw, 2.4rem)",
              color: "#F7F7F7",
              letterSpacing: "0.04em",
            }}>
              HOL
            </div>
            <div style={{
              marginTop: 8,
              fontFamily: "Inter, sans-serif",
              fontSize: "0.72rem",
              letterSpacing: "0.32em",
              textTransform: "uppercase",
              color: "rgba(212, 175, 55, 0.85)",
            }}>
              Creative Solutions
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
